import React, { FC, ReactElement, useState, } from "react";

import { PoolRollResult, RerollModal, } from ".";
import { Button, ButtonColor, ButtonStyle, } from "components/FormControls";
import { classNames } from "components/Utils";

type Props = {
    result: PoolRollResult;
    onReroll: (pool: number[]) => void;
};

export const RerollCard: FC<Props> = (props: Props): ReactElement => {
    const { result, onReroll, } = props;
    const [isModalVisible, setIsModalVisible] = useState(false);

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };

    const button = (
        <Button
            style={ButtonStyle.Pill}
            onClick={toggleModal}
            label={"reroll"}
            color={ButtonColor.Warning}
        />
    );

    const handleReroll = (pool: number[]) => {
        onReroll(pool);
        setIsModalVisible(false);
    };

    const modal = !isModalVisible ?
        <></> :
        <RerollModal dice={result.pool} onCancel={toggleModal} onReroll={handleReroll} />;

    const containerCss = classNames([
        "__rerollbanner__",
        "bd-callout",
        "bd-callout-info",
    ]);
    const cardCss = classNames([
        "card",
        // "bg-light",
        // "text-bg-info","
    ])

    return (
        <>
            <div className={containerCss}>
                <div className={cardCss}>
                    <div className="card-body">One point of <strong>Willpower</strong> can be spent to {button} up to <strong>three</strong> non-hunger dice.</div>
                </div>
            </div>

            {modal}
        </>
    );
};
